<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="m-3 lifedi-color">
        {{ title }}
      </h1>
    </div>
  </div>
</div>

<div *ngIf="allDetail" class="container">
  <div class="row justify-content-center">
    <div class="col-12">

      <nz-table #groupingTable [nzData]="allDetail" nzBordered nzSize="large" class="table table-striped">
        <thead>
          <tr>
            <th class="text-center" style="width: 150px;">วันที่</th>
            <th class="text-center">รายละเอียด</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let detail of groupingTable.data;">
            <td class="text-center">{{ detail.date | date }}</td>
            <td>{{ detail.description }}</td>
          </tr>
        </tbody>
      </nz-table>

    </div>
  </div>
</div>
